import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { verifyTokenExpire } from "middleware/verifyToken";
import { verifyPermission } from "helpers/permission";
import appConfig from "config/appConfig";

const endPointConfig = {
  PRO: {
    plan: "PRO",
    get: `${appConfig.apiDomaine}/quota-delay/treatment`,
    update: `${appConfig.apiDomaine}/quota-delay/treatment`,
  },
  MACRO: {
    holding: {
      get: `${appConfig.apiDomaine}/quota-delay/treatment`,
      update: `${appConfig.apiDomaine}/quota-delay/treatment`,
    },
    filial: {
      get: `${appConfig.apiDomaine}/quota-delay/treatment`,
      update: `${appConfig.apiDomaine}/quota-delay/treatment`,
    },
  },
};

export const useQuotaData = (plan, userPermissions) => {
  const [isLoading, setIsLoading] = useState(true);
  const [quotaData, setQuotaData] = useState({
    unite: "",
    staff: "",
    traitement: "",
    validation: "",
    satisfaction: "",
  });
  const [error, setError] = useState(null);

  const getEndpoint = () => {
    if (plan === "MACRO") {
      if (
        verifyPermission(
          userPermissions,
          "list-config-reporting-claim-any-institution"
        )
      ) {
        return endPointConfig[plan].holding;
      } else if (
        verifyPermission(
          userPermissions,
          "list-config-reporting-claim-my-institution"
        )
      ) {
        return endPointConfig[plan].filial;
      }
    }
    return endPointConfig[plan];
  };

  const endpoint = getEndpoint();

  const fetchQuotaData = useCallback(async () => {
    if (!verifyTokenExpire()) return;

    try {
      setIsLoading(true);
      const response = await axios.get(endpoint.get);

      setQuotaData({
        unite: response?.data?.assignment_unit || "",
        staff: response?.data?.assignment_staff || "",
        traitement: response?.data?.assignment_treatment || "",
        validation: response?.data?.assignment_validation || "",
        satisfaction: response?.data?.assignment_measure_satisfaction || "",
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [endpoint.get]);

  useEffect(() => {
    fetchQuotaData();
  }, [fetchQuotaData]);

  return { quotaData, isLoading, error, endpoint };
};
